import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as $ from 'jquery';

import { ITab } from '../ts/stores/AppStore';
import { HTMLDivRef } from '../ts/Interfaces';

const SINGLE_TAB_TITLE_HEIGHT = 50;

export function LayoutContainerSize(props: {
    width: number;
    height: number;
    disableSizeMixin?: boolean;
    navigationBarHeight: number;
    navigationBarlIsPinned: boolean;
    noTabsMode: boolean;
    tabs: ITab[];
    workspaceName: string;

    children?: React.JSX.Element | React.JSX.Element[];

    onChange(width: number, height: number): void;
}) {
    const viewportRef = React.useRef<HTMLDivElement>(null);

    React.useEffect(() => {
        const setViewport = () => {
            let width: number;
            let height: number;

            const node = viewportRef.current;

            if (node != null) {
                width = node.offsetWidth;
                height = node.offsetHeight;

                if ((props.width === width && props.height === height) || width === 0 || height === 0) {
                    return;
                }
            } else {
                width = null;
                height = null;
            }

            if (props.onChange != null) {
                props.onChange(width, height);
            }
        };

        const handleWindowResize = (e) => {
            setViewport();
        };

        if (!props.disableSizeMixin) {
            $(window).on('resize', handleWindowResize);

            setViewport();
        }

        return () => {
            if (!props.disableSizeMixin) {
                $(window).off('resize', handleWindowResize);
            }
        };
    });

    let height: number;
    let style: React.CSSProperties;
    let sindleTabTitleElement: React.JSX.Element;

    if (props.navigationBarlIsPinned && props.navigationBarHeight > 4) {
        height = props.navigationBarHeight;
    }

    if (props.noTabsMode) {
        if (height == null) {
            height = 0;
        }

        const tabs = props.tabs;

        if (tabs != null && tabs.length > 0) {
            const firstTab = tabs[0];

            let tabTitle = firstTab.title;

            if (tabTitle == null) {
                tabTitle = props.workspaceName;
            }

            sindleTabTitleElement = (
                <div
                    className="single-tab-title"
                    style={{
                        height: SINGLE_TAB_TITLE_HEIGHT + 'px',
                        top: height + 'px'
                    }}
                >
                    {tabTitle}
                </div>
            );
        }

        height += SINGLE_TAB_TITLE_HEIGHT;
    }

    if (height != null) {
        style = {
            top: height + 4 + 'px'
        };
    }

    return (
        <>
            {sindleTabTitleElement}

            <div className={'content'} ref={viewportRef} style={style}>
                {props.children}
            </div>
        </>
    );
}

export function useLayoutContainerSizeHook(
    disableSizeMixin: boolean,
    viewportRef: HTMLDivRef,
    deps: React.DependencyList = []
) {
    const [viewporSizes, setViewporSizes] = React.useState<{
        viewportWidth?: number;
        viewportHeight?: number;
    }>({ viewportWidth: null, viewportHeight: null });

    const setViewport = React.useCallback(() => {
        if (viewportRef.current == null) {
            setViewporSizes({
                viewportWidth: null,
                viewportHeight: null
            });
        } else {
            const { offsetWidth, offsetHeight } = viewportRef.current;

            if (
                (viewporSizes.viewportWidth === offsetWidth && viewporSizes.viewportHeight === offsetHeight) ||
                offsetWidth === 0 ||
                offsetHeight === 0
            ) {
                return;
            }

            setViewporSizes({
                viewportWidth: offsetWidth,
                viewportHeight: offsetHeight
            });
        }
    }, [viewporSizes]);

    React.useEffect(() => {
        if (!disableSizeMixin) {
            $(window).on('resize', setViewport);
            setViewport();
        }

        return () => {
            if (!disableSizeMixin) {
                $(window).off('resize', setViewport);
            }
        };
    }, [disableSizeMixin, [...deps]]);

    return viewporSizes;
}
